<template>
<v-list-item @click="$emit('selected', member)" :value="member.id" >
  <!-- <v-list-item-action v-if='withMore' >
    <v-btn icon ><v-icon>mdi-dots-vertical</v-icon></v-btn>
  </v-list-item-action> -->
  <v-list-item-avatar >
    <v-img
      v-if='member.practitioner_media.profile'
      :src='member.practitioner_media.profile' >
    </v-img>
    <v-avatar v-else color='teal' dark class='white--text' >
      <span v-text='initials' />
    </v-avatar>
  </v-list-item-avatar>
  <v-list-item-content >

    <v-list-item-title v-if="member.practitioner_name" >
      {{member.practitioner_name}}
      <v-chip label dark x-small color="green" >{{member.role}}</v-chip>
    </v-list-item-title>

    <v-list-item-subtitle >
      {{member.practitioner_profession}}
      <!-- <v-chip x-small dark label
        color='info' class='ml-2' >{{member.role}}
      </v-chip> -->
      <!-- <v-chip x-small dark label
        v-if='member.is_dependent'
        color='info' class='ml-2' >Dependent
      </v-chip> -->
      <v-chip
        v-if='member.is_active === false'
        x-small label color='amber' class='ml-2' >Deactivated</v-chip>
    </v-list-item-subtitle>
    <v-list-item-subtitle >
      <template v-if='member.activation_date' >
        Active since {{dateformat(member.activation_date)}}
      </template>
    </v-list-item-subtitle>
  </v-list-item-content>
  <slot name='actions' >
    <v-list-item-action v-if='to' >
      <v-btn :to='to' icon ><v-icon>mdi-chevron-right</v-icon></v-btn>
    </v-list-item-action>
  </slot>
  <!-- {{member}} -->
</v-list-item>
</template>
<script>
export default {
  name: 'MemberListItem',
  props: {
    value: { type: Object, required: true },
    withMore: { type: Boolean, default: true },
    to: { type: String, required: false }
  },
  data () {
    return {
      member: {}
    }
  },
  computed: {
    initials () {
      if (this.member && this.member.practitioner_name) {
        let items = this.member.practitioner_name.split(' ')
        if (items && items.length > 0) {
          return items.slice(0, 2).map((word) => { return word[0] }).join('')
        }
      }
      return ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.member = this.value
        }
      }
    }
  }
}
</script>
